import en from './en.json';
import tr from './tr.json';
import phrases from './phrases.json';
import events from './events.json';
import { translateTraderMessage } from './messages';

const pair = (source, target, result = {}) => { for (const [key, value] of Object.entries(source)) { if (typeof value === 'object') pair(value, target?.[key], result); else result[value] = target?.[key] || value; } return result; };
const dictionary = { ...pair(en, tr), ...phrases, ...events };
const reverse = Object.fromEntries(Object.entries(dictionary).filter(([source, target]) => source !== target && !source.startsWith('en-')).map(([source, target]) => [target, source]));

// Only UI strings are passed here. Trading enum values and API payloads stay raw.
export const translateTraderText = (text, language, variables) => {
  if (typeof text !== 'string') return text;
  const trimmed = text.trim();
  const translated = language === 'tr' ? dictionary[trimmed] ?? translateTraderMessage(trimmed) : reverse[trimmed];
  let value = translated === undefined ? text : text.slice(0, text.indexOf(trimmed)) + translated + text.slice(text.indexOf(trimmed) + trimmed.length);
  if (variables) value = value.replace(/\{(\w+)\}/g, (match, name) => variables[name] ?? match);
  return value;
};